module.exports = __webpack_public_path__ + "static/media/Power.4a6d63e8.svg";